// extracted by mini-css-extract-plugin
export default {"root":"IconProfile_root__hl3xl"};